import Login from "./Pages/Login/Login";
import { Route, BrowserRouter, Switch, Redirect } from "react-router-dom";
import Dashboard from "./Pages/dashboard/dashboard";
import "./App.css";

const App = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route exact path="/">
          <Redirect to="/login" />
        </Route>
        <Route path="/" component={Dashboard} />
      </Switch>
    </BrowserRouter>
  );
};

export default App;
